import { type WordToken } from "../../../../helpers/scriptHelpers";
import { useState } from "react";
import { styled } from "styled-components";
import { Form, GlobalToken, Popover } from "antd";
import { PronunciationForm } from "./PronunciationForm";
import { VoiceoverPopoverTitle } from "../VoiceoverPopoverTitle";

export const PronunciationToken = ({
  token,
  isSelected,
  addSpaceAfterToken,
  onTokenClick,
  onCancel,
  onConfirm,
  sectionId,
  voiceId,
}: {
  token: WordToken;
  isSelected: boolean;
  addSpaceAfterToken: boolean;
  onTokenClick: (token: WordToken) => void;
  onCancel: () => void;
  onConfirm: (pronunciation: string | null) => void;
  sectionId?: string;
  voiceId?: string;
}) => {
  const [form] = Form.useForm();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const hasPronunciation = !!token.pronunciation && isSelected;

  return (
    <Popover
      open={isPopoverOpen}
      onOpenChange={(open) => {
        if (open) {
          form.setFieldsValue({ pronunciation: token.pronunciation });
        }
        setIsPopoverOpen(open);
      }}
      trigger="click"
      placement="top"
      title={
        <VoiceoverPopoverTitle
          hasItem={hasPronunciation}
          onDelete={() => {
            onConfirm(null);
            setIsPopoverOpen(false);
          }}
          addKey="pronunciation.addPronunciation"
          editKey="pronunciation.editPronunciation"
        />
      }
      content={
        <PronunciationForm
          form={form}
          token={token}
          sectionId={sectionId}
          voiceId={voiceId}
          onFinish={(values) => {
            onConfirm(values.pronunciation);
            setIsPopoverOpen(false);
          }}
          onCancel={() => {
            form.resetFields();
            onCancel();
            setIsPopoverOpen(false);
          }}
        />
      }
      styles={{
        body: {
          padding: 0,
        },
      }}
    >
      <PronunciationSpan
        key={token.index}
        onClick={() => onTokenClick(token)}
        style={{
          cursor: "pointer",
          position: "relative",
        }}
        $isSelected={isSelected}
      >
        {token.word}
        {addSpaceAfterToken && " "}
      </PronunciationSpan>
    </Popover>
  );
};

const PronunciationSpan = styled.span<{
  theme: GlobalToken;
  $isSelected: boolean;
}>`
  cursor: pointer;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ $isSelected, theme }) =>
    $isSelected ? theme.colorPrimary : "transparent"};
  border-radius: 4px;
  padding: 0.5px;
  &:hover {
    border-color: ${({ theme }) => theme.colorPrimary};
  }
`;
